/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FinancialSupportDemoGrantBenefitDto } from '../../models/financial-support-demo-grant-benefit-dto';

export interface FinancialSupportDemoControllerFindGrantBenefits$Params {
  id: string;
}

export function financialSupportDemoControllerFindGrantBenefits(http: HttpClient, rootUrl: string, params: FinancialSupportDemoControllerFindGrantBenefits$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<FinancialSupportDemoGrantBenefitDto>>> {
  const rb = new RequestBuilder(rootUrl, financialSupportDemoControllerFindGrantBenefits.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<FinancialSupportDemoGrantBenefitDto>>;
    })
  );
}

financialSupportDemoControllerFindGrantBenefits.PATH = '/api/financial-support/demo-companies/{id}/grant-benefits';
